import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=d746b3a4&"
var script = {}
import style0 from "./termsOfService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d746b3a4')) {
      api.createRecord('d746b3a4', component.options)
    } else {
      api.reload('d746b3a4', component.options)
    }
    module.hot.accept("./termsOfService.vue?vue&type=template&id=d746b3a4&", function () {
      api.rerender('d746b3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/termsOfService.vue"
export default component.exports